import banner from "../assets/banner.png";
import pfp from "../assets/pfp.png";
import NavBar from "../Components/NavBar";

import location from "../assets/map-pin.svg";
import gift from "../assets/gift.svg";
import edit from "../assets/edit.svg";

import "../assets/Profile.css";

import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';

const section = (map) => {
    var arr = []
    map.forEach((value, key) => {
        arr.push(<div>
            <div className="name">{key}</div>
            {value.split('\n').map(item => <div>{item}</div>)}
        </div>);
    });

    return <div>{arr}</div>
}

export const Profile = () => {
    
    const [showPopup, setPopup] = useState(false);
    const [name, setName] = useState("Abigail");
    const [user, setUser] = useState("AbigailDoe");
    const [pronouns, setPronouns] = useState("she/they");
    const [loc, setLoc] = useState("Bermuda Triangle");
    const [bday, setBday] = useState("February 30th, 2025");
    const [nick, setNick] = useState("Abby");
    const [timeline, setTimeline] = useState(new Map([
        [
            'XXXX Elementary School', 
            'Kindergarten: Mr. XXXX\n1st Grade: Mrs. XXXX\n2nd Grade: Mrs. XXXX\n3rd Grade: Mr. XXXX\n4th Grade: Mx. XXXX\n5th Grade: Mr. XXXX'], 
        [
            'XXXX Middle School',
            '6th Grade Life Sciences with Mrs. XXXX\n6th Grade Common Core 7/8 Math with Mr. XXXX\n6th Grade Social Studies with Mx. XXXX\n8th Grade Geoemtry with Mrs. XXXX'], 
        [
            'XXXX High School',
            '11th Grade AP Computer Science A with Mx. XXXX',
            '11th Grade AP Calculus BC with Ms. XXXX']
    ]));

    const [editName, setEditName] = useState(name);
    const [editUser, setEditUser] = useState(user);
    const [editPronouns, setEditPronouns] = useState(pronouns);
    const [editLoc, setEditLoc] = useState(loc);
    const [editBday, setEditBday] = useState(bday);
    const [editNick, setEditNick] = useState(nick);

    return (<div>
        <NavBar />

        <div className="profile">
            <div className="banner-container">
                <img className="banner" src={banner} alt="banner" />
            </div>

            <div className="profile-info">
                <div className="pfp-container">
                    <img className="pfp" src={pfp} alt="pfp" />
                </div>
                <div className="name">{name}</div>
                <div className="more-info">
                    <div className="username">@{user}</div>
                    <div className="username">{nick}</div>
                    <div className="username">{pronouns}</div>

                    <div className="location">
                        <img src={location} className="logo" alt="location logo" />
                        {loc}
                    </div>
                
                    <div className="bday">
                        <img src={gift} className="logo" alt="birthday logo" />
                        Born {bday}
                    </div>
                </div>
                <div className="edit-btn-container">
                    <div className="edit-btn" onClick={() => setPopup(true)}>
                        <div className='edit-btn-text'>EDIT PROFILE</div>
                        <img src={edit} className="logo" alt="edit logo" />
                    </div>
                </div>
            </div>
            <div className="timeline">
                <h3>Timeline</h3>
                <div className="time-info">
                    {section(timeline)}
                </div>
            </div>
        </div>
        <Modal show={showPopup}
               onHide={() => setPopup(false)}>
            <Modal.Header>
                <Modal.Title>Edit Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5>Name</h5>
                <input 
                    type="text" 
                    value={editName}
                    onChange={(event) => setEditName(event.target.value)}
                    placeholder="name"
                />
                <h5>Username</h5>
                <input 
                    type="text" 
                    value={"@" + editUser}
                    onChange={(event) => setEditUser(event.target.value.substring(1))}
                    placeholder="username"
                />
                <h5>Nicknames</h5>
                <input 
                    type="text"
                    value={editNick}
                    onChange={(event) => setEditNick(event.target.value)}
                    placeholder="nicknames"
                />
                <h5>Pronouns</h5>
                <input 
                    type="text"
                    value={editPronouns}
                    onChange={(event) => setEditPronouns(event.target.value)}
                />
                <h5>Location</h5>
                <input 
                    type="text" 
                    value={editLoc}
                    onChange={(event) => setEditLoc(event.target.value)}
                    placeholder="location"
                />
                <h5>Birthday</h5>
                <input 
                    type="text" 
                    value={editBday}
                    onChange={(event) => setEditBday(event.target.value)}
                    placeholder="birthday"
                />
                <h5>Timeline</h5>
                Under Construction
            </Modal.Body>
            <Modal.Footer className="edit-footer">
                <div className="save-btn" onClick={() => {
                    setPopup(false);
                    setName(editName);
                    setUser(editUser);
                    setLoc(editLoc);
                    setBday(editBday);
                    setNick(editNick);
                    setPronouns(editPronouns);
                }}>save</div>
                <div className="cancel-btn" onClick={() => {
                    setPopup(false);
                    setEditName(name);
                    setEditUser(user);
                    setEditLoc(loc);
                    setEditBday(bday);
                    setEditNick(nick);
                    setEditPronouns(pronouns);
                }}>cancel</div>
            </Modal.Footer>
        </Modal>
    </div>);
}

export default Profile;
